/* eslint-disable */

import request from '@/utils/request'

export function getListFromReception(query) {
  return request({
    url: '/cashier-service/v1/room-transaction-payment',
    method: 'get',
    params: query
  })
}

export function setDateEqual(data) {
  return request({
    url: '/cashier-service/v1/room-transaction-payment',
    method: 'put',
    data: data
  })
}

export function postDebtTransfer(id) {
  return request({
    url: `/cashier-service/v1/room-transaction/debt-transfer/${id}`,
    method: 'post'
  })
}

export function downloadInvoiceListFromReception(query) {
  return request({
    url: '/cashier-service/v1/room-transaction-payment/export-excel',
    method: 'get',
    params: query,
    responseType: 'arraybuffer'
  })
}
